type ServiceRequestStatusKeyString = {
  [key: string]: {
    color: string
    label: string
    key: string
  }
}

export const SERVICE_REQUEST_STATUS_OBJECT: ServiceRequestStatusKeyString = {
  PENDING: {
    label: 'Pendente',
    key: 'PENDING',
    color: 'yellow',
  },
  INVESTIGATING: {
    label: 'Em atendimento',
    key: 'INVESTIGATING',
    color: 'blue',
  },
  ACCEPTED: {
    label: 'Aprovado',
    key: 'ACCEPTED',
    color: 'green',
  },
  REJECTED: {
    label: 'Rejeitado',
    key: 'REJECTED',
    color: 'red',
  },
}
